import { Component } from '@angular/core';
@Component({
  selector: 'page-navigation',
  templateUrl: './page-navigation.component.html',
  styleUrls: ['./page-navigation.component.scss', './page-navigation-700.component.scss']
})
export class PageNavigationComponent {
}
